/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CapTableRail {
    LEGAL = 'LEGAL',
    BENEFICIAL = 'BENEFICIAL',
}
